/**
 * @deprecated LEGACY: Backward compatibility için korunuyor.
 * Yeni kod için @/api veya domain modüllerini (@/api/auth.api vb.) kullanın.
 */
import api from "@/api";

export default api;
